import { memo } from 'react';
import Lottie from 'lottie-react';

import djAnimation from '@/features/letterParty/assets/lottie/dj-level-1.json';

interface DjLevelProps {
	className?: string;
	score?: number;
}

const DjLevel = ({ className, score = 0 }: DjLevelProps) => {
	return (
		<div className={`letter-party-game__dj-level ${className ?? ''}`}>
			<Lottie animationData={djAnimation} loop className="letter-party-game__dj-level-animation" />
			<span className="letter-party-game__dj-level-score">{score}</span>
		</div>
	);
};

export default memo(DjLevel);
